import { api } from "api";
import { useFeatureFlag } from "./useFeatureFlag";
import { useQueryClient } from "@tanstack/react-query";
import type { ExistingPatient } from "components/PaymentsLanding/NewPaymentModal/existingPatient";

/**
 * Hook to identify whether unmerge capability (for testing purposes) is in effect and applicable.
 * If so, provides a function that will call the unmerge API to unmerge patient passed to hook.
 * For manual testing purposes only.
 */
export function useUnmerge(prp: ExistingPatient, after: () => void) {
    const patientId = prp?.id ?? -1;
    const queryClient = useQueryClient();

    const flagged = !!useFeatureFlag("pms-patient-unmerge", false);
    if (flagged) console.warn("pms-patient-unmerge feature engaged", prp);

    return canUseUnmerge(flagged, prp)
        ? async () => {
              await api.provider.unmergePatient(patientId);
              void queryClient.invalidateQueries({
                  queryKey: ["patientActivity"],
              });
              after();
          }
        : null;
}

const canUseUnmerge = (flagged: boolean, prp: ExistingPatient) => {
    return flagged && (prp?.pmsId?.length ?? 0) > 0 && (prp?.id ?? 0) > 0;
};
